import { ValidatorsModule } from './component/core/validatos/validatos.module';
import { NgModule } from '@angular/core';
import { AppComponentModule } from './component/app-component.module';
import { AppServiceModule } from './service/app-service.module';


@NgModule({
  imports: [
    AppComponentModule,
    AppServiceModule,
    ValidatorsModule,
  ],
  exports: [
    AppComponentModule,
    AppServiceModule,
    ValidatorsModule,
  ]
})
export class AppCoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/app-core.module.ts